// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1d75be2a","409":"5d8cb543","689":"48c54edd","849":"c01854a8"}[chunkId] + ".chunk.js";
};